import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";

// import { graph } from '@pnp/graph';
// import { MSGraphClient } from '@microsoft/sp-http';
// import { WebPartContext } from "@microsoft/sp-webpart-base";

import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import { escape, fromPairs } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import  * as uuidv4 from "uuid/v4";
import  { Reply } from "./Reply";


import { getAuthenticatedClient } from "../../auth/authClient";
var graph = require('@microsoft/microsoft-graph-client');

/**
 * 
 * @param param0 props params is assigned to variables
 * {
 * @param teamId 
 * @param channelId 
 * @param messageId
 * @param context 
 * }
 */
export  function RepliesContainer({teamId, channelId, messageId, accessToken, pageNumber}) {

    const [repliesList, setRepliesList] = useState(null);
    const { dispatch, state } = useContext(MessagesContext);
    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    //const [showMessages, setShowMessages] = useState(false);
    //console.log(`@RepliessContainer ACCESSTOKEN: ${accessToken}`);

    log.info(`@RepliesContainer`);
    log.debug(`@RepliesContainer accessToken: ${accessToken}`);

      useEffect(() => {
        log.info(`useEffect @ RepliesContainer`);
        getReplies(teamId, channelId, messageId, accessToken, pageNumber )
        //setRepliesList( response.value );      
      }, [accessToken]);



  
     
/**
 * const getReplies
 * Gets the replies based on @microsoft/sp-http client
 * @param teamId 
 * @param channelId 
 * @param replyId 
 * @param msGraphClient 
 */
    const getReplies = async (teamId, channelId, messageId, accessToken, pageNumber) =>{
      log.info(`getReplies @ RepliesContainer`);
      const _top = state.numberOfItemsInPage;
      const _skip = _top*(pageNumber-1); 
      const oDataQuery = `?$top=${_top}&$skip=${_skip}`;

      //https://graph.microsoft.com/beta/teams/{group-id-for-teams}/channels/{channel-id}/messages/{message-id}/replies/
      const repliesUrl = `/teams/${teamId}/channels/${channelId}/messages/${messageId}/replies${oDataQuery}`; //MESSAGES_URL;
         
      const client = getAuthenticatedClient(accessToken);
      try{
      const res = await client
              .api(repliesUrl)
                .headers({
                  "Content-Type" : "application/json;charset=UTF-8",
                   "mode": "cors",
                  "Access-Control-Allow-Origin" : '' 
                })
                .version('beta')
                .get((error, replies, rawResponse) => {
                    if (replies) {
                      let someReplies =    replies.value.filter(reply =>{                         
                        if (reply.body.content.length > 0 ) return true;
                        return false;
                      });
                        const  selectedReplies =   someReplies.map(reply => {
                        const _reply = 
                        {
                           id :  reply.id,
                           date: reply.createdDateTime ? reply.createdDateTime : `not availabe`,
                           text :  `[Reply:] ${reply.body.content}`,
                           webUrl : reply.webUrl,
                           user : reply.from.user.displayName,
                           type : "Reply",
                           selected : false 
                        };
                        return _reply;
                    });

                    const selectedRepliesReversed = [...selectedReplies].reverse()  
                    setRepliesList(selectedRepliesReversed); 
                    return selectedRepliesReversed;
                    } else {
                        return [];
                    }
                  }
                );
     
              } catch (error) {
                log.error(`getReplies @ RepliesContainer error: ${JSON.stringify(error)}`);
             } finally {
               log.info(`finally / getReplies @ RepliesContainer`);
             }                
    }
      



    // return (
    //   <div>
    //     {repliesList.map((reply) => (
    //       <>
    //            <Reply
    //               key={uuidv4()}
    //               teamID={teamId}
    //               channelId={channelId}
    //               messageId={messageId}
    //               reply={reply}
    //               accessToken={accessToken}
    //           />
    //       </>
    //     ))}
    //   </div>
    // );  

    const MyErrorComponent = ({error})=>{
      log.info(` MyErrorComponent @ RepliesContainer`);
      log.error(` MyErrorComponent @ RepliesContainer error ${error.message}`);
      return (
        <div >Error. Search in Logs for details.</div>
      )
    }


    const renderReplies = ()=>{

      if (repliesList == null || repliesList == undefined ){
        return (
          <>  
          <Spinner size={SpinnerSize.large} />
          </> 
        )
      }

      const _repliesList = repliesList.map((reply) => (
        <ErrorBoundary  
              render={() => 
                            <Reply
                              key={uuidv4()}
                              teamID={teamId}
                              channelId={channelId}
                              messageId={messageId}
                              reply={reply}
                              accessToken={accessToken}
                            />
                      }
            renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}
            >
            </ErrorBoundary>              
          )          
      )
      return _repliesList;
    }

    return (
      <>
        {renderReplies()}
      </>
    )
}
  
// <li key={create_UUID()}>
//               <a href={message.webUrl}>{message.content.substr(0,50)} </a>
//             </li>

//    const context = this.props.context;
//const graphClient = await context.msGraphClientFactory.getClient();
//const appsResponse = await graphClient.api('appCatalogs/teamsApps').version('v1.0').get();
//const _context = this.context;

  //-------------------------
// const getMessagesMe = async (teamId, channelId, context) =>{
//     console.log(`@getMessages >  teamId - ${teamId} , channelId - ${channelId}`);
//     context.msGraphClientFactory
//     .getClient()
//     .then((client: MSGraphClient)=> {
//             client
//             .api('/me')
//             .get((error, user, rawResponse) => {
//                 console.log('@getMessages >  user ' + JSON.stringify(user));
//                 return [{}];
//                 }
//             );
  
//                         //console.log('msGraphClient: ' + JSON.stringify(msGraphClient))  
                                
                                
//                                 // const _me =  await msGraphClient.api('/me').get();
//                                 // const _meValue = _me.value
//                                 // console.log ('me: ' + JSON.stringify(_me));
//                                 // return _meValue; //_messages;
//             }
//     )};

